import { InjectionToken } from '@angular/core';
import { DateFnsI18n } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DATE_FNS_I18N: InjectionToken<DateFnsI18n> = new InjectionToken<DateFnsI18n>('dateFnsI18n');
